import { sanitizeAddress } from 'services/query/hooks'

export const getParamsForIndexInfoData = (address: string) => INDEX_PRODUCT_INFO_QUERY(address)

export const INDEX_PRODUCT_INFO_QUERY = (address: string): string => {
  return `
        query {
          indexes(where: { id: "${sanitizeAddress(address)}" }) {
            id
            name
            symbol
            version
            k
            mintingFee
            aumFee
            redemptionFee
            creationDate
            totalFees
            totalSupply
            assets {
              chainID
              chainIndex
              latestSnapshot
              assets {
                chainID
                name
                asset
                balance
                decimals
                symbol
                currencyID
                weight
              }
            }
          }}
      `
}
